import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Update icon — a pair of arrows in a refresh loop.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const UpdateIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M10.0535 3.5C12.2589 3.50017 14.1916 4.66344 15.2625 6.40527C15.4069 6.64049 15.3336 6.9482 15.0984 7.09277C14.8633 7.23718 14.5555 7.16374 14.4109 6.92871C13.5157 5.47261 11.8996 4.50017 10.0535 4.5C7.26479 4.5 5.00568 6.7171 4.95584 9.46289L5.22146 9.2002C5.41747 9.006 5.73408 9.0073 5.92849 9.20312C6.12295 9.39911 6.12148 9.71565 5.92557 9.91016L4.80545 11.0215C4.6105 11.2148 4.29625 11.2149 4.10135 11.0215L2.98123 9.91016C2.78556 9.71563 2.7849 9.39903 2.97928 9.20312C3.17379 9.00746 3.4904 9.00584 3.68631 9.2002L3.95584 9.46777C4.00315 6.16028 6.71808 3.5 10.0535 3.5Z"
      fill="currentColor"
    />
    <path
      d="M15.1907 8.97837C15.3855 8.78585 15.6991 8.78585 15.8938 8.97837L17.0179 10.0897C17.2141 10.2838 17.2158 10.6004 17.0218 10.7967C16.8276 10.9929 16.511 10.9947 16.3147 10.8006L16.0393 10.5292C15.9938 13.84 13.2677 16.5008 9.92118 16.5008C7.70883 16.5007 5.76867 15.3385 4.69364 13.5965C4.54866 13.3615 4.62175 13.0531 4.85673 12.9081C5.09172 12.7631 5.40019 12.8362 5.54521 13.0711C6.44377 14.5272 8.06632 15.5007 9.92118 15.5008C12.7249 15.5008 14.9917 13.2792 15.0393 10.5331L14.7698 10.8006C14.5735 10.9947 14.2569 10.9928 14.0628 10.7967C13.8687 10.6004 13.8704 10.2838 14.0667 10.0897L15.1907 8.97837Z"
      fill="currentColor"
    />
  </svg>
);

export default UpdateIcon;
